import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BackToTop, Footer } from "../components/common";
import { Header } from "../components/common";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import logo from "../assets/img/CheckIDBioSense_light.svg";
import logoWhite from "../assets/img/CheckIDBioSense_dark.svg";

export const MainLayout = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [bg, setBg] = useState("bg-home bg-right-top bg-no-repeat");
  const [logoImg, setLogoImg] = useState(logo);
  // set Logo & Background & title
  useEffect(() => {
    switch (location.pathname) {
      case "/":
        setBg("bg-home bg-right-top bg-no-repeat  xl:!bg-[center_top_0rem]");
        setLogoImg(logo);
        document.title = "CheckID BioSense Service | Mobile-ID";
        break;
      case "/biosense-visitor-management":
        setBg("bg-home bg-right-top bg-no-repeat");
        setLogoImg(logo);
        document.title = t("products.facialsensevisitormanagement.titlepage");
        break;
      case "/biosense-bio-attendance":
        setBg("bg-home bg-right-top bg-no-repeat  ");
        setLogoImg(logo);
        document.title = t("products.bioattendance.titlepage");
        break;
      case "/office-employee-time-attendance-monitoring-system":
        setBg("bg-industries w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.biometricoffice.titlepage");
        break;

      case "/retail-workforce-time-attendance-monitoring-system":
        setBg("bg-industries w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.retailworkforce.titlepage");
        break;
      case "/mobile-workforce-time-attendance-monitoring-system":
        setBg("bg-industries w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.mobileandremote.titlepage");
        break;
      case "/biometric-school-attendance-monitoring-system":
        setBg("bg-industries w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.student.titlepage");
        break;
      case "/construction-site-time-attendance-monitoring-system":
        setBg("bg-industries w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.constructtion.titlepage");
        break;
      case "/hospital-time-attendance-monitoring-system":
        setBg("bg-industries w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.healthcare.titlepage");
        break;
      case "/service-and-hospitality-time-attendance-monitoring-system":
        setBg("bg-industries w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.service.titlepage");
        break;
      case "/factory-and-warehouse-employee-time-attendance-monitoring-system":
        setBg("bg-industries w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.factory.titlepage");
        break;
      case "/agriculture-sector-time-attendance-monitoring-system":
        setBg("bg-industries w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.agriculture.titlepage");
        break;
      case "/meet-a-person-in-organization":
        setBg("bg-organization w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.organizations.titlepage");
        break;
      case "/travel-and-excursion":
        setBg("bg-organization w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.travel.titlepage");
        break;
      case "/banking-or-financial-institutes":
        setBg("bg-organization w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.banking.titlepage");
        break;
      case "/hotels-and-restaurants":
        setBg("bg-organization w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.hotel.titlepage");
        break;
      case "/consultation-services":
        setBg("bg-organization w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.consultation.titlepage");
        break;
      case "/buildings-and-apartments":
        setBg("bg-organization w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.building.titlepage");
        break;
      case "/customer-support":
        setBg("bg-organization w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.customer.titlepage");
        break;
      case "/entertainment":
        setBg("bg-organization w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.entertainment.titlepage");
        break;
      case "/schools-and-campuses":
        setBg("bg-organization w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("industries.school.titlepage");
        break;
      case "/pricing":
        setBg("bg-industries w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("pricing.titlepage");
        break;
      case "/company":
        setBg("bg-company w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title =
          "CheckID BioSense Company | BioSense Visitor Management";
        break;
      case "/about-us":
        setBg("bg-company w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("aboutus.titlepage");
        break;
      case "/contact-us":
        setBg("bg-company w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("contactus.titlepage");
        break;
      case "/register-as-a-distributor":
        setBg("bg-company w bg-center-top bg-no-repeat max-w-full");
        setLogoImg(logoWhite);
        document.title = t("registerasadistributor.titlepage");
        break;
      default:
        setBg("bg-home bg-right-top bg-no-repeat xl:!bg-left-top");
        setLogoImg(logo);
        document.title = "CheckID BioSense Service | Mobile-ID";
        break;
    }
  }, [location, i18n.language]);

  return (
    <main className={`${bg}  lg:!bg-left-top bg-[100% 100%] exact1024:bg-contain smAndmd:bg-contain minxl:bg-contain`}>
      <Header logo={logoImg} />
      <Outlet />
      <Footer />
      <BackToTop />
    </main>
  );
};
